import { Page } from "@/models/page-models/Page";

export const PrintZebraLabel: Page = {
  "path": "print-zebra-label",
  "name": "Print Zebra Label",
  "props": {
    "data": {
      "title": "Print Zebra Label",
      "printable": "FALSE",
      "url": "print-zebra-label",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.lotNumber",
                  "label": "Select Order",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyLabelDetails",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "sourceFn",
                        "arg2Value": "getLabelDetails",
                        "arg3Key": "destinationKey",
                        "arg3Value": "formData",
                        "arg4Key": "append",
                        "arg4Value": "TRUE",
                        "arg5Key": "destinationKeyType",
                        "arg5Value": "Object"
                      },
                      "name": "copyLabelDetails"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.orders.data.docs",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,orderDescription,{{__item}})",
                  "dropdownType": "search",
                  "searchFunctions": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyOrderSearchString",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.ordersForm.search"
                      },
                      "name": "copyOrderSearchString"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getAllOrders",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/order/get",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.orders",
                        "arg3Key": "postData",
                        "arg3Value": "fetchedData.ordersForm"
                      },
                      "name": "getAllOrders"
                    }
                  ]
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.customer",
                  "label": "CUSTOMER"
                },
                {
                  "type": "label",
                  "variable": "formData.itemName",
                  "label": "ITEM"
                },
                {
                  "type": "label",
                  "variable": "formData.lotNumber",
                  "label": "LOT#/JOB"
                },
                {
                  "type": "label",
                  "variable": "formData.palletType",
                  "label": "PALLET TYPE"
                }
              ],
              "showIf": "{{formData.lotNumber}}"
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.irms",
                  "label": "IRMS/GCAS#"
                },
                {
                  "type": "label",
                  "variable": "formData.supplierCode",
                  "label": "SUPPLIER CODE"
                },
                {
                  "type": "label",
                  "variable": "formData.quantity",
                  "label": "QUANTITY"
                },
                {
                  "type": "label",
                  "variable": "formData.numberOfRolls",
                  "label": "NO. OF ROLLS/PKTS"
                }
              ],
              "showIf": "{{formData.lotNumber}}"
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.quantity",
                  "label": "QUANTITY",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.numberOfRolls",
                  "label": "NO. OF ROLLS",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "{{formData.lotNumber}}"
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.weight",
                  "label": "WEIGHT (KG)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.numberOfLabels",
                  "label": "No Of Labels(No of Cartons)",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "{{formData.lotNumber}}"
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.shiftDate",
                  "label": "Production Date",
                  "disabled": "FALSE",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyExpiryDate",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getExpiryDate",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyExpiryDate"
                    }
                  ]
                },
                {
                  "type": "datepicker",
                  "variable": "formData.expiryDate",
                  "label": "Expiry Date",
                  "disabled": "FALSE",
                  "showResetOption": true
                },
                {
                  "type": "input",
                  "variable": "formData.shiftNumber",
                  "label": "Shift Number(00 - 99)",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "{{formData.lotNumber}}"
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print Carton Label (New)",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "printLabel",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/printer/generateNewLabel",
                        "arg2Key": "postData",
                        "arg2Value": "formData",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "printLabel"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ],
              "showIf": "{{formData.lotNumber}}",
              "disabled": "fn(LOGICAL,fn(MULTIPLY,{{formData.quantity}},{{formData.numberOfRolls}}),==,0)"
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyOrdersForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getOrdersForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.ordersForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyOrdersForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getAllOrders",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/order/get",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.orders",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.ordersForm"
        },
        "name": "getAllOrders"
      }
    ],
    "functions": [
      {
        "name": "getLabelDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "palletType": "NONE",
          "quantity": "fn(CONDITIONAL,fn(LOGICAL,{{__selectedObject.product.packingMode.1.quantity}},>,0),fn(MULTIPLY,{{__selectedObject.product.packingMode.0.quantity}},{{__selectedObject.product.packingMode.1.quantity}}),{{__selectedObject.product.packingMode.0.quantity}})",
          "irms": "{{__selectedObject.product.customerItemId}}",
          "numberOfRolls": "fn(CONDITIONAL,fn(LOGICAL,{{__selectedObject.product.packingMode.1.quantity}},>,0),{{__selectedObject.product.packingMode.1.quantity}},1)",
          "itemName": "fn(HELPER_FN,productAlias,{{__selectedObject.product}},false)",
          "customer": "{{__selectedObject.customer.name}}",
          "supplierCode": "{{__selectedObject.customer.supplierCode}}",
          "productLine": "{{__selectedObject.productLine}}",
          "customerId": "{{__selectedObject.customer._id}}",
          "shiftDate": "fn(HELPER_FN,dateFormat,{{TODAYS_DATE}},date-picker)",
          "expiryDate": "fn(HELPER_FN,dateFormat,fn(ADD_DAYS,{{TODAYS_DATE}},fn(CONDITIONAL,fn(LOGICAL,fn(LOGICAL,'{{__selectedObject.productLine}}',==,'Ribbon'),||,fn(LOGICAL,'{{__selectedObject.productLine}}',==,'Wet Wipes')),12,6),month),date-picker)"
        },
        "useFormula": true
      },
      { 
        "name": "getOrdersForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      },
      {
        "name": "getExpiryDate",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "expiryDate": "fn(HELPER_FN,dateFormat,fn(ADD_DAYS,{{formData.shiftDate}},fn(CONDITIONAL,fn(LOGICAL,fn(LOGICAL,'{{formData.productLine}}',==,'Ribbon'),||,fn(LOGICAL,'{{formData.productLine}}',==,'Wet Wipes')),12,6),month),date-picker)"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "PRODUCTION_PLANNER",
  "visible": true
}